import { get } from '@/api/request'

// Helper to rewrite backend OSS URLs to frontend edge proxy URLs
const rewriteDataImages = (data: any) => {
    if (!data) return data
    try {
        const str = JSON.stringify(data)
        const backendDomain = "https://console.mysovi.ai/api/blade-resource/oss/endpoint/get-static-file/"
        const frontendFriendlyPath = `${window.location.origin}/sovi-files/`
        // Use regex global replace instead of replaceAll for better browser compatibility
        const newStr = str.replace(new RegExp(backendDomain.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g'), frontendFriendlyPath)
        return JSON.parse(newStr)
    } catch (e) {
        return data
    }
}

/**
 * 获取已发布的博客文章列表
 */
export const getBlogList = async (params?: { category?: string; current?: number; size?: number }) => {
    const query = new URLSearchParams()
    if (params?.category) query.set('category', params.category)
    if (params?.current) query.set('current', String(params.current))
    if (params?.size) query.set('size', String(params.size))
    const qs = query.toString()
    const res: any = await get(`/api/solve-x-ai/blog/article/list${qs ? '?' + qs : ''}`)
    if (res && res.data) {
        res.data = rewriteDataImages(res.data)
    }
    return res
}

/**
 * 根据 slug 获取博客文章详情
 */
export const getBlogDetail = async (slug: string) => {
    const res: any = await get(`/api/solve-x-ai/blog/article/detail?slug=${encodeURIComponent(slug)}`)
    if (res && res.data) {
        res.data = rewriteDataImages(res.data)
    }
    return res
}

/**
 * 获取博客分类列表
 */
export const getBlogCategories = () => {
    return get('/api/solve-x-ai/blog/category/list')
}